import { Box, Stack, useTheme } from "@mui/material";
import {
  AvailablePaymentCurrency,
  formatSmartNarrowCurrencyFromCents,
  GIFT_AID_PLUS_VALUE_PERCENTAGE,
} from "@simplyk/common";

import { FormDivider } from "../../../../components/forms-design-system/FormDivider";
import { FormIcon } from "../../../../components/forms-design-system/FormIcon";
import { useLocaleContext } from "../../../../contexts/LocaleContext";
import { useTranslate } from "../../../../hooks/useTranslate";

import { FormTypography } from "@/forms-design-system/FormTypography";
import { InvalidThemeErrorMessage } from "@/forms-design-system/InvalidThemeErrorMessage";
import { Check } from "@/icons/filled";

interface GiftAidCertifiedAlertProps {
  amount: number;
  organizationName: string;
}

export const GiftAidCertifiedAlert = ({ amount, organizationName }: GiftAidCertifiedAlertProps) => {
  const theme = useTheme();
  const { isoLocale } = useLocaleContext();
  const { t } = useTranslate();

  if (!theme.palette.forms || !theme.palette.formsComponents?.giftAidBlock) {
    return <InvalidThemeErrorMessage />;
  }

  return (
    <Box
      sx={{
        color: theme.palette.formsComponents.giftAidBlock.alertTextColor,
        fontSize: "14px",
        fontWeight: 600,
        gap: theme.spacing(1),
      }}
    >
      <Box sx={{ my: 2 }}>
        <FormDivider />
      </Box>
      <Stack direction="row" alignItems="center" gap={1}>
        <FormIcon size="large">
          <Check color={theme.palette.formsComponents.giftAidBlock.iconColor} />
        </FormIcon>
        <FormTypography variant="subtitle2" vibe="brand">
          {t("dashboard", "giftAidBlock.alert.title", {
            organizationName,
            newAmount: formatSmartNarrowCurrencyFromCents((1 + GIFT_AID_PLUS_VALUE_PERCENTAGE) * amount, {
              locale: isoLocale,
              currency: AvailablePaymentCurrency.Gbp,
            }),
          })}
        </FormTypography>
      </Stack>
    </Box>
  );
};
